<template>
  <a
    v-if="!is_notifications_sidebar_open"
    v-tooltip.bottom="is_customer ? null : $t('notification.title')"
    data-test="sidebar-notifications-user"
    :class="anchor_class"
    @click="toggleSidebar"
  >
    <FontAwesomeIcon
      :icon="['far', 'bell']"
      data-test="notifications-number"
    />
    <span
      v-if="show_notification_point"
      data-test="notification-dot"
      :class="dot_class"
    />
  </a>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';

const CUSTOMER_CLASS =
  'relative inline-flex size-10 cursor-pointer items-center justify-center rounded-full text-lg text-gray-500 md:bg-gray-200 md:shadow-md';
const STAFF_CLASS =
  'relative flex size-8 cursor-pointer items-center justify-center rounded-full text-neutral-500 hover:bg-selected hover:text-neutral-800';

const store = useStore();

const current_profile = computed(() => store.getters.current_profile);
const sidebar_type = computed(() => store.getters.sidebar_type);
const notifications_sidebar_last_opened_at = computed(() => store.getters.notifications_sidebar_last_opened_at);

const is_notifications_sidebar_open = computed(() => sidebar_type.value === SIDEBAR_NOTIFICATIONS);

const is_customer = computed(
  () =>
    !!current_profile.value &&
    current_profile.value.type !== PROFILE_TYPES.EMPLOYEE &&
    current_profile.value.type !== PROFILE_TYPES.PARTNER,
);

const anchor_class = computed(() => (is_customer.value ? CUSTOMER_CLASS : STAFF_CLASS));

const dot_class = computed(() =>
  is_customer.value
    ? 'absolute top-2 right-2 size-2 rounded-full bg-danger-500 md:top-0 md:right-0.5'
    : 'absolute top-1 right-1 size-2 rounded-full bg-danger-500',
);

const show_notification_point = computed(() => {
  const notified_at = _.get(current_profile.value, 'attributes.notified_at', new Date(0).toISOString());
  return notified_at > notifications_sidebar_last_opened_at.value;
});

onMounted(() => store.dispatch('INIT_NOTIFICATIONS_LAST_OPENED'));

function toggleSidebar() {
  store.dispatch('SHOW_SIDEBAR', is_notifications_sidebar_open.value ? null : SIDEBAR_NOTIFICATIONS);
}
</script>
